import React from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard
import Home from "./components/Dashboard/Home";

import Task from "./components/Dashboard/Task";

import ScrollToTop from "./layouts/ScrollToTop";
import UserList from "./pages/UserList";
import AppConfig from "./pages/AppConfig/AppConfig";
import CategoryConfig from "./pages/AppConfig/CategoryConfig";
import JobPosting from "./pages/JobPosting";
import ServicePosting from "./pages/ServicePosting";
import JobDetails from "./pages/JobDetails";
import Price from "./pages/Price";
import Flag from "./pages/Flag";
import UserDetails from "./pages/UserDetails";
import SubEvents from "./pages/SubEvents";
import TaskPage from "./pages/Tasks";

import Co_host_Detail from "./pages/Co_host_Detail";
import EventDetails from "./pages/EventDetails";
import Guest from "./pages/Guest";
import UserEvents from "./pages/UserEvents";
import Co_Hosts from "./pages/Co_Hosts";
import UnEnroll from "./pages/UnEnroll";
import Notification from "./pages/Notification";
import AddFAQPage from "./pages/New_Faq";
import Legal_INFO from "./pages/LegaInfo";
import LegalInfo from "./pages/LegaInfo";
import Resources from "./pages/Resources";
 
import Terms from "./pages/TermsConditon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Education from "./pages/Education";
import Promotion from "./pages/Promotion";
import About from "./pages/About";
import { Search } from "lucide-react";
import SearchCompoment from "./pages/Search";
import Admins from "./pages/Admins";
import Appointments from "./pages/Appointments";
import CaseForm from "./pages/CaseForm";
import Dashboard from "./pages/DashBoard";
import Dashboards from "./pages/DashBoard";
import CaseDetails from "./pages/CaseDetails";
import AppointmentDetails from "./pages/AppointmentDetails";
 

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    /// Dashboard
    { url: "", component: <Dashboards /> },
    
    { url: "category", component: <AppConfig /> },
    { url: "category-config", component: <CategoryConfig /> },
    { url: "task", component: <Task /> },
    { url: "user-management", component: <UserList /> },
    // { url: "job-posting", component: <JobPosting /> },
    { url: "service-posting", component: <ServicePosting /> },
    { url: "job-details", component: <JobDetails /> },
    { url: "price", component: <Price /> },
    { url: "report", component: <Flag /> },
    { url: "user-details", component: <UserDetails /> },
    { url: "user-details/:id", component: <UserDetails /> },
    { url: "sub-events/:id1/:id2", component: <SubEvents /> },
    { url: "tasks/:id1/:id2", component: <TaskPage /> },
    { url: "co-host/:id", component: <Co_host_Detail /> },
    { url: "event_details/:id", component: <EventDetails /> },
    { url: "guests/:id1/:id2", component: <Guest /> },
     { url: "user_events/:id", component: <UserEvents /> },
     { url: "add-services", component: <JobPosting/>},
     { url: "add-faq", component: <AddFAQPage/>},
        { url: "admins", component: <Admins/> },
          { url: "co_hosts", component: <Co_Hosts/> },
    { url: "terms-condition", component: <Terms/> },
                { url: "faqs", component: <UnEnroll/> },
 { url: "legal-info", component: <LegalInfo/> },
 { url: "appointments", component: <Appointments/> },
  { url: "appointments/:id", component: <AppointmentDetails/> },
  { url: "cases", component: <CaseForm/> },
    { url: "dashboards", component: <Dashboards/> },
                             { url: "services", component: <Notification/> },
                             { url: "resources", component: <Resources/> },
                                 { url: "privacy-policy", component: <PrivacyPolicy/> },
                                  { url: "education", component: <Education/> },
                                               { url: "promotion", component: <Promotion/> },
                                               { url: "about", component: <About/> },
                                                           { url: "search", component: <SearchCompoment/> },
                                                             { url: "case-details/:id", component: <CaseDetails/> },
  ];

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  //const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show`}>
        {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>   */}
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 140 }}
        >
          <div className="container-fluid bdy">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
function FrontLayout() {
  return (
    <>
      <div className="overflow-unset">
        {/* <Layout /> */}
        <Outlet />
      </div>
    </>
  );
}

export default Markup;
